import React from 'react';
import { Container, Typography } from '@mui/material';

const Nominations = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" sx={{ mt: 4 }}>
        Nominations
      </Typography>
    </Container>
  );
};

export default Nominations; 